function AttachmentsController() {
    this.constructor.apply(this, arguments);
}

AttachmentsController.$inject = ['$scope', '$element', '$q', 'Upload', 'MKioskService', 'AttackmentService', '$mdDialog','UtilityService'];
AttachmentsController.prototype = {
    /**
     *
     * @param $scope {angular.IScope}
     * @param $element {angular.IRootElementService}
     * @param $q {angular.IPromise}
     * @param Upload {Upload}
     * @param MKioskService {MKioskService}
     * @param AttackmentService {AttackmentService}
     * @param $mdDialog {$mdDialog}
     * @param UtilityService {UtilityService}
     */
    constructor($scope, $element, $q, Upload, MKioskService, AttackmentService, $mdDialog, UtilityService) {
        this.$scope = $scope;
        this.$element = $element;
        this.$q = $q;
        this.Upload = Upload;
        this.MKioskService = MKioskService;
        this.attackmentService = AttackmentService;
        this.$mdDialog = $mdDialog;
        this.utilityService = UtilityService;


        // Declare variables
        /** @type IAttachment[] */
        this.$files = [];

        /** @type number */
        this.fileItemWidth = 0;



        this.$scope.vm = this;

        //create canvas
        this.canvas = document.createElement("canvas");
        this.context = this.canvas.getContext("2d");

        this.canvas2 = document.createElement("canvas");
        this.context2 = this.canvas2.getContext("2d");

        this.watch();
    },


    watch() {
        /**
         * Watch for changes in $files
         * @param {IAttachment[]} newValues
         */
        this.$scope.$watchCollection("$files",
            /**
             *
             * @param newValues {IAttachment[]}
             */
            (newValues) => {
                this.$files = newValues || [];
                this.fileItemWidth = this.getFileItemWidth();
                if (newValues) {
                    let newFiles = newValues.filter((file) => {
                        return file.isNew;
                    });

                    // Upload files
                    if (this.$scope.autoUpload && newFiles.length > 0) {
                        this.uploadFiles(newFiles);
                    }


                    // Resize, Rotate thumnails
                    let imagesNotYetRender = newFiles.filter((file) => {
                        return !file.isRenderingThubnail && !file.ThumbnailUrl;
                    });
                    if (this.$scope.renderableThumbnails && imagesNotYetRender.length > 0) {
                        this.renderThumbnails(imagesNotYetRender)
                    }

                }
            });

        // destroy
        this.$scope.$on("$destroy", () => {
            //Release memory when close page
            this.$files.forEach(($file) => {
                this.releaseFile($file);
            })
        });

        // Re-compute with when image reize
        this.$element.resize( ()=> {
            this.fileItemWidth = this.getFileItemWidth();
            this.safeApply();
        });
    },

    destroy() {
        // Release canvas
        $(this.canvas).remove();
        $(this.canvas2).remove();
        delete this.context;
        delete this.context2;
        delete this.canvas;
        delete this.canvas2;
    },

    getClassStatus($file) {
        var classes = [];
        // Status
        switch ($file.uploadStatus) {
            case UploadStatus.Completed:
                classes.push("upload-completed");
                break;
            case UploadStatus.Fail:
                classes.push("upload-fail");
                break;
            case UploadStatus.Pending:
                classes.push("upload-pending");
                break;
        }
        if($file.isNew){
            classes.push('is-new');
        }
        if($file.isPhoto) {
            classes.push('is-image');
        } else {
            classes.push('is-file');
        }

        if(this.$scope.getClass){
            let item =  this.$scope.getClass({$file: $file});
            if(item) {
                classes.push(item);
            }
        }

        return classes;
    },


    /**
     * Upload  files to server
     * @param {IFile[]} $files
     */
    uploadFiles($files) {
        $files.forEach(($file) => {
            if ($file.uploadStatus === UploadStatus.Pending)
                this.upload($file);
        })
    },

    /**
     * Upload a file to server
     * @param {IFile} $file
     * @returns {any}
     */
    upload($file) {
        //upload file
        var upload = this.MKioskService.uploadFile($file);
        upload.then((response) => {
            if ($file.removed)
                return;
            $file.DocumentId = response.data.Id;
            $file.uploadStatus = UploadStatus.Completed;
            this.$scope.$emit("upload_completed", $file);
            this.safeApply();
        }, () => {
            if ($file.removed)
                return;
            $file.uploadStatus = UploadStatus.Fail;
            this.$scope.$emit("upload_fail", $file);
            this.safeApply();
        }, (evt) => {
            if (evt.total > 0) {
                if ($file.removed)
                    return;
                $file.progress = Math.min(100, parseInt((100 * evt.loaded / evt.total).toString()));
                this.$scope.$emit("upload_in_progress");
                this.safeApply();
            }
        });
        //Abort upload
        upload.xhr((xhr) => {
            upload.abort = () => {
                xhr.abort();
            };
        });
        $file.upload = upload;
        return upload;
    },

    /**
     *
     * @param imageList {File[]}
     * @param index {number}
     * @param callback {Function}
     */
    renderThumbnail(imageList, index, callback) {
        var $file = imageList[index];
        $file.isRenderingThubnail = true;
        this.getThumbnail(imageList[index]).then((result) => {
            $file.ThumbnailUrl = result.thumbnail;
            $file.DownloadUrl = result.fileUrl;
            $file.orientation = result.orientation;
            $file.neededRotation = result.neededRotation;
            if ($file.thumbnailOnLoaded)
                $file.thumbnailOnLoaded();
            this.safeApply(() => {
                if (index === imageList.length - 1) {
                    callback();
                } else {
                    this.renderThumbnail(imageList, index + 1, callback);
                }
            });
        });
    },

    /**
     * Get thumbnail of  files
     * @param $files {File[]}
     * @returns {angular.IPromise<void>}
     */
    renderThumbnails($files) {
        var deferred = this.$q.defer();
        if ($files.length > 0) {
            this.renderThumbnail($files, 0, () => {
                deferred.resolve();
            });
        } else {
            deferred.resolve();
        }
        return deferred.promise;
    },
    safeApply(fn) {
        var phase = this.$scope.$root.$$phase;
        if (phase === '$apply' || phase === '$digest') {
            if (fn && (typeof (fn) === 'function')) {
                fn();
            }
        } else {
            this.$scope.$apply(fn);
        }
    },
    getThumbnail($file) {
        return this.applyExifRotation($file, this.$scope.options);
    },
    applyExifRotation(file, options) {
        return this.getOrientation(file).then((orientation) => {
            return this.Upload.dataUrl(file).then((url) => { // convert file to to url
                return this.resizeAndRotate(url, orientation, options);
            });
        });
    },
    getOrientation(file) {
        return this.$q((resolve, reject) => {
            if (file.type.indexOf('image/jpeg') !== 0) {
                resolve(0);
            }
            this.Upload.readOrientation(file).then((result) => {
                resolve(result.orientation);
            }, (e) => {
                reject(e);
            });
        });
    },
    resizeAndRotate(url, orientation, options) {
        return this.$q((resolve, reject) => {
            var img = new Image();
            img.onload = () => {
                try {
                    var imgWidth = img.width, imgHeight = img.height, centerCrop = options.centerCrop,
                        width = options.width, height = options.height;
                    if (!width) {
                        width = imgWidth;
                    }
                    if (!height) {
                        height = imgHeight;
                    }
                    var dimensions = this.calculateAspectRatioFit(imgWidth, imgHeight, width, height, centerCrop),
                        resizeWidth = Math.min(dimensions.width, width),
                        resizedHeight = Math.min(dimensions.height, height);
                    //Reisze image
                    var canvas = this.canvas,
                        ctx = this.context;
                    canvas.width = resizeWidth;
                    canvas.height = resizedHeight;
                    //@ts-ignore
                    ctx.drawImage(img, 0, 0, resizeWidth, resizedHeight);
                    var neededRotation = false;
                    if (orientation >= 2 && orientation <= 8) {
                        neededRotation = true;
                    }
                    var dataUrl ;
                    if (neededRotation) {
                        //Rotate image
                        var canvasRotate = this.canvas2, ctxRotate = this.context2;
                        canvasRotate.width = orientation > 4 ? resizedHeight : resizeWidth;
                        canvasRotate.height = orientation > 4 ? resizeWidth : resizedHeight;
                        this.applyTransform(ctxRotate, orientation, resizeWidth, resizedHeight);
                        //@ts-ignore
                        ctxRotate.drawImage(canvas, 0, 0);
                        dataUrl = canvasRotate.toDataURL('image/WebP', 0.934);
                    } else {
                        dataUrl = canvas.toDataURL('image/WebP', 0.934);
                    }
                    var blob = this.Upload.dataUrltoBlob(dataUrl),
                        thumbnail = URL.createObjectURL(blob);
                    resolve({
                        thumbnail: thumbnail,
                        orientation: orientation,
                        neededRotation: neededRotation,
                        fileUrl: url
                    });
                } catch (e) {
                    return reject(e);
                }
            };
            img.onerror = (e) => {
                reject(e);
            };
            img.src = url;
        });
    },
    calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight, centerCrop) {
        var ratio = centerCrop ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight) :
            Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
        return {
            width: srcWidth * ratio, height: srcHeight * ratio,
            marginX: srcWidth * ratio - maxWidth, marginY: srcHeight * ratio - maxHeight
        };
    },
    releaseFile($file) {
        try {
            $file.removed = true;
            //Cancel upload
            if ($file.upload) //Fix if file size is 0
                $file.upload.abort();
            if ($file.thumbnail)
                URL.revokeObjectURL($file.thumbnail);
            if ($file.fileUrl)
                URL.revokeObjectURL($file.fileUrl);
        } catch (e) {
            console.log(e);
        }
    },
    removeAttachmentFile($file) {
        for (var i = 0; i < this.$files.length; i++) {
            if (this.$files[i].Id === $file.Id) {
                this.$files.splice(i, 1);
                break;
            }
        }
        this.releaseFile($file);

        if(this.$scope.onRemoved){
            this.$scope.onRemoved({
                $file: $file
            });
        }
    },
    getFileItemWidth() {
        let options = this.$scope.options;
        let minWidth = options.width;
        var number = this.$element.find(".attachment-container").width() / minWidth;
        number = Math.round(number);
        if (number === 1)
            number = 2;
        return (1 / number) * 100;
    },
    /**
     *
     * @param $file {IAttachment}
     * @param $event {MouseEvent}
     */
    showAttachmentDetail($file, $event) {
        $event.preventDefault();
        if (this.$scope.onFileSelected) {
            this.$scope.onFileSelected({
                $file: $file
            });
        } else {
            if ($file.DownloadUrl) {
                if (this.attackmentService.isPhoto($file.DownloadUrl)) {
                    this.utilityService.showImageViewer($file, this.$files, $event);
                } else {
                    if (window['cordova']) {
                        window['cordova'].InAppBrowser.open($file.DownloadUrl, '_system');
                    } else {
                        window.open($file.DownloadUrl, '_blank');
                    }
                }
            }
        }


    },


    /**
     * Show description modal
     * @param {IFile} $file
     * @param $event {MouseEvent}
     */
    showDescriptionModal($file, $event) {
        $event.stopPropagation();

        function DescriptionController($mdDialog, description) {
            this.$mdDialog = $mdDialog;
            this.description = description;
        }

        DescriptionController.$inject = ['$mdDialog', 'description'];
        DescriptionController.prototype = {
            submit() {
                this.$mdDialog.hide(this.description);
            },
            onCancel() {
                this.$mdDialog.cancel();
            }
        }

        this.$mdDialog.show({
            controller: DescriptionController,
            controllerAs: 'vm',
            templateUrl: 'js/internal/vehiclebookings/pickup/pickup-comment.html',
            targetEvent: $event,
            clickOutsideToClose: true,
            escapeToClose: true,
            focusOnOpen: true,
            hasBackdrop: true,
            locals: {
                description: $file.Description
            }
        }).then((description) => {
            $file.Description = description;
        });
    },

}
angular.module('shared').directive('nfAttachments', () => {
    return {
        restrict: 'E',
        controller: AttachmentsController,
        templateUrl: 'js/shared/directives/attachments/attachments.html',
        compile: function(element, attrs){
            if (attrs.deletable===undefined) {
                attrs.deletable = "true";
            }
            if (attrs.description===undefined) {
                attrs.description = "false";
            }
            if (attrs.options===undefined) {
                attrs.options = JSON.stringify({
                    width: 120
                })
            }
            if (attrs.autoUpload===undefined) {
                attrs.autoUpload = "true";
            }
            if (attrs.renderableThumbnails===undefined) {
                attrs.renderableThumbnails = "true";
            }


        },
        scope: {
            $files: '=',
            deletable: "=",
            description: '=',
            options: '=',
            autoUpload: "=",
            getClass: '&?',
            renderableThumbnails: "=",
            onFileSelected: "&?",
            onRemoved: "&?"
        }
    };
});